// OP-3617 — A referência de um lançamento do razão como link para a tela de
// origem, quando o backend manda o id numérico; sem id, texto puro.
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { DocumentoReferencia } from '../../../types/estoque'
import { CELULAR } from '../styles'
import { rotaDaReferencia, textoDaReferencia } from './referencia'

export const Ancora = styled.a`
  @media ${CELULAR} {
    display: inline-flex;
    align-items: center;
    min-height: 44px;
  }
`

export { rotaDaReferencia } from './referencia'

export const RefLink: FC<{ tipo: string; codigo: string | null; id?: number | null; documento?: DocumentoReferencia | null }> = ({
  tipo, codigo, id, documento,
}) => {
  const navigate = useNavigate()
  const texto = textoDaReferencia(tipo, codigo, documento)
  const rota = rotaDaReferencia(tipo, id, codigo, documento)
  if (!rota) return <>{texto}</>
  return (
    <Ancora href={rota} onClick={(e) => { e.preventDefault(); e.stopPropagation(); navigate(rota) }}>{texto}</Ancora>
  )
}

export default RefLink
